<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-col cols="12" sm="6" md="6">
      <v-row class="ml-6" dense>
        <v-card v-for="item in cardItems" :key="item.name" :elevation="2" :class="{
          'selected-card': selectedCard === item.name,
          'default-card': selectedCard !== item.name
        }" class="back-hover pa-2 mx-2 d-flex align-center justify-center" @click="selectCard(item.name)">
          <img v-if="item.icon" :src="item.icon" width="24" height="24" class="mr-2" />
          <b :class="{
            'selected-text': selectedCard === item.name,
            'default-text': selectedCard !== item.name
          }">
            <span class="text-no-wrap">{{ item.label }}</span>
          </b>
        </v-card>
      </v-row>
    </v-col>

    <v-col cols="12" class="mt-2">
      <component :is="selectedComponent"></component>
    </v-col>
  </div>
</template>

<script>
import epsHeader from "../shared/UpdatedHeader";

const componentsMap = {
  "default-values": () => import("@/components/RoleManagement/DefaultValues"),
  "default-type-value": () => import("@/components/RoleManagement/DefalultTypeValue"),
  "configuration-master": () => import("@/components/Admission/AdmissionMaster/ConfigurationMaster"),
};

export default {
  components: {
    epsHeader,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    selectedCard: null,
    selectedComponent: null,
    cardItems: [
      {
        name: "default-values",
        label: "Default Values",
        icon: "https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/Role Management/Default_values.png",
      },
      {
        name: "default-type-value",
        label: "Default Value Type",
        icon: "https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/Role%20Management/Defualt_value_type.png",
      },
      {
        name: "configuration-master",
        label: "Configuration Master",
        icon: "https://wws-schoolerp.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/1/configurationwlu4ay79re.png",
      },
    ],
  }),
  methods: {
    async selectCard(cardName) {
      this.selectedCard = cardName;
      try {
        if (componentsMap[cardName]) {
          const component = await componentsMap[cardName]();
          this.selectedComponent = component.default;
        }
      } catch (error) {
        console.error("Component loading failed", error);
      }
    },
  },
};
</script>

<style scoped>
.back-hover {
  /* transition: transform 0.3s ease, box-shadow 0.3s ease; */
  /* border-radius: 999px !important; */
  /* capsule shape */
  min-height: 48px;
}

.back-hover:hover {
  transform: translateY(-4px);
  /* box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.2) !important; */
}

.selected-card {
  color: white;
  background-color: var(--v-brand-base);
  border: 2px solid rgb(81, 81, 81);
  box-shadow: inset 0 0 0 9999px rgba(0,0,0,0.1);
}

.default-card {
  color: white;
  background-color: var(--v-brand-base);
}

.selected-text {
  font-size: 14px;
}

.default-text {
  font-size: 14px;
}
</style>
